const config = {
	apiUrl: process.env.REACT_APP_API_URL,
	mapboxKey: process.env.REACT_APP_MAPBOX_KEY,
};

export default config;
